import { render, staticRenderFns } from "./SearchBook.vue?vue&type=template&id=5faa2a88&scoped=true"
import script from "./SearchBook.vue?vue&type=script&lang=js"
export * from "./SearchBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faa2a88",
  null
  
)

export default component.exports